export default __webpack_public_path__ + "static/media/vehicle-2.a719c8aa.png";